import React from 'react'

const ArrowRight = ({ size = 40, color = '#129878', bgColor = '#E8F7F4', ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 40 40"
		fill="none"
		{...props}
	>
		<rect width="40" height="40" rx="20" fill={bgColor} />
		<path
			d="M15.3333 20H24.6666"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M20 24.6667L24.6666 20L20 15.3333"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export default ArrowRight
